module.exports = __webpack_public_path__ + "static/media/codemage.8dc2b9b3.svg";